import airbrake from "/services/airbrake";
import globals from "/utils/globals";

export default message => {
  if (airbrake && globals.env === "production") {
    airbrake.notify(message);
  } else {
    throw new Error(message);
  }
};
